import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import styled from '@emotion/styled';
export var StyledFieldError = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: relative;\n\toverflow: hidden;\n\t/*\n\t * -4px aligns the error's straight side borders to the input's rounded border\n\t * -1px aligns the error's box-shadow to the input's box-shadow\n\t * 4px re-aligns sibling elements due to the -4px top margin\n\t */\n\tmargin: -4px -1px 4px -1px;\n"])));
export var StyledFieldErrorMessage = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\ttransition: padding-top 0.3s;\n\ttransition-delay: ", ";\n\tmargin-top: ", ";\n\tpadding-top: ", "px;\n"])), function (_ref) {
  var elementOffset = _ref.elementOffset;
  return elementOffset ? '0.3s' : '0s';
}, function (_ref2) {
  var elementOffset = _ref2.elementOffset;
  return !!elementOffset ? "-".concat(elementOffset, "px") : '-100%';
}, function (_ref3) {
  var elementOffset = _ref3.elementOffset;
  return elementOffset;
});